import React from 'react';
import PropTypes from 'prop-types';
import Avatar from 'react-avatar';

import AppPoint from 'components/App/AppPoint';
import AppLink from 'components/App/AppLink';
import AppTableEmpty from 'components/App/AppTableEmpty';

import { ReactComponent as NoItem } from 'assets/images/NoReview.svg';
import { LOCATIONS } from 'constants/index';
import { convertIsoDateToString } from 'utils';

import styles from './ReviewDataTableList.module.scss';

function ReviewDataTableList(props) {
  const { placeId, list } = props;

  // const RoomNameRender = React.useCallback((values) => {
  //   if (!isEmpty(setting[PARAM_SETTING.BED_TYPES])) {
  //     const roomNamesSetting = setting[PARAM_SETTING.ROOM_NAMES];

  //     const { parentRoomName, roomName } = values;

  //     const roomNameParentFilter = roomNamesSetting.filter((roomNameItem) => (
  //       roomNameItem.name === parentRoomName
  //     ));

  //     const roomNamesFilter = roomNameParentFilter[0].children.filter((childrenItem) => (
  //       childrenItem.name === roomName
  //     ));

  //     return roomNamesFilter[0].vi;
  //   }

  //   return '';
  // }, [setting]);

  // const BedTypesRender = React.useCallback(
  //   (bedTypeFilter) => {
  //     if (
  //       !isEmpty(setting[PARAM_SETTING.BED_TYPES])
  //       && !isEmpty(bedTypeFilter)
  //     ) {
  //       const bedTypesSetting = setting[PARAM_SETTING.BED_TYPES];

  //       const bedType = bedTypesSetting[0].children.filter(
  //         (childrenItem) => childrenItem.name === bedTypeFilter[0].bedType,
  //       );

  //       return bedType[0].vi;
  //     }

  //     return '';
  //   },
  //   [setting],
  // );

  return (
    <div className={styles.Component}>
      <table className={styles.TableWrap}>
        <colgroup>
          <col span="1" />
          <col span="1" />
          <col span="1" />
          <col span="1" />
          <col span="1" />
        </colgroup>

        <thead className={styles.TableHeading}>
          <tr>
            <th>Tên khách hàng</th>
            <th>Đặt phòng</th>
            <th>Nội dung đánh giá</th>
            <th>Điểm đánh giá</th>
            <th>Thời gian đánh giá</th>
          </tr>
        </thead>

        <tbody className={styles.TableBody}>
          {list.map((item) => (
            <tr key={item._id}>
              <td className={styles.ItemUserWrapper}>
                <div className={styles.ItemUser}>
                  <div className={styles.ImageWrap}>
                    <Avatar
                      src={item?.user?.avatar}
                      alt="avatar"
                      size={32}
                      round
                      name={item?.user?.fullName}
                    />
                  </div>

                  <p className={styles.ItemUserName}>{item?.user?.fullName}</p>
                </div>

                <AppLink
                  href={{
                    pathname: LOCATIONS.LOCATION_DETAIL.REVIEW_DETAIL,
                    search: `?place=${placeId}&review=${item._id}`,
                  }}
                  className={styles.ItemLinkDetail}
                >
                  Xem chi tiết
                </AppLink>
              </td>

              <td>
                {/* hidden temporary */}
                {/* {item.userBooking.rooms.map((room) => (
                  <div className={styles.ItemBooking} key={room.roomName}>
                    <p>
                      {`${RoomNameRender({
                        parentRoomName: room.parentRoomName,
                        roomName: room.roomName,
                      })} - ${BedTypesRender(
                        room.bedTypes.filter(
                          (bedTypeItem) => bedTypeItem.quantity > 0,
                        ),
                      )}`}
                    </p>

                    <p>
                      {`${convertIsoDateToString(
                        item.userBooking.startedAt,
                      )} - ${convertIsoDateToString(item.userBooking.endedAt)}`}
                    </p>
                  </div>
                ))} */}
                <div className={styles.ItemBooking}>
                  <p>
                    {item.userBooking.orderId}
                  </p>

                  <p>
                    {`${convertIsoDateToString(
                      item.userBooking.startedAt,
                    )} - ${convertIsoDateToString(item.userBooking.endedAt)}`}
                  </p>
                </div>
              </td>

              <td>
                <p className={styles.ItemComment}>{item.content}</p>
              </td>

              <td>
                <AppPoint
                  point={item.overviewReview}
                  className={styles.ItemPoint}
                />
              </td>

              <td>
                <p className={styles.ItemCreatedAt}>
                  {convertIsoDateToString(item.createdAt)}
                </p>
              </td>
            </tr>
          ))}

          {list.length === 0 && (
          <AppTableEmpty>
            <div className={styles.EmptyItem}>
              <NoItem />

              <p>Bạn hiện chưa có đánh giá</p>
            </div>
          </AppTableEmpty>
          )}
        </tbody>
      </table>
    </div>
  );
}

ReviewDataTableList.propTypes = {
  placeId: PropTypes.string,

  list: PropTypes.instanceOf(Array),
};

ReviewDataTableList.defaultProps = {
  placeId: '',

  list: [],
};

export default React.memo(ReviewDataTableList);
